import { styled } from 'linaria/react';

export const StyledImageWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    opacity: 0;
    animation: fadeIn 0.3s cubic-bezier(0.33, 0, 0.3, 1) forwards, scaleUp 1.17s ease-out forwards,
      cardSize 1.17s ease-in-out 1.9s infinite;

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes scaleUp {
      from,
      73% {
        width: 96px;
        height: 96px;
      }
      to {
        width: 188px;
        height: 188px;
      }
    }

    @keyframes cardSize {
      0% {
        width: 188px;
        height: 188px;
      }
      50% {
        width: 156px;
        height: 156px;
      }
      100% {
        width: 188px;
        height: 188px;
      }
    }
  }
`;
